module.exports = __webpack_public_path__ + "static/media/Icon material-mode-edit.917d1518.svg";